import { gql } from '@apollo/client';

export const GET_CRM_TAGS = gql`
    query GetCrmTags {
        getCrmTags {
            _id
            tags {
                key
                label
                color
            }
        }
    }
`;
